<template>
  <div class="md-layout">
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header truncated_header m-0"
    >
      <div class="md-layout md-alignment-center">
        <div
          class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-60 p-0"
        >
          <h4>Company Profile</h4>
          <ul>
            <li>
              <h6>
                <i class="md-icon">business</i>Company:
                <p>{{ headerData.companyTitle }}</p>
              </h6>
            </li>
            <li>
              <h6>
                <i class="md-icon">business_center</i>Industry:
                <p>{{ headerData.industry }}</p>
              </h6>
            </li>
          </ul>
        </div>
        <div class="md-layout-item md-medium-size-100 md-size-40 button-box">
          <md-button class="md-info access-button pdf_btn" @click="feedback">
            <md-icon>comment</md-icon>Product Feedback
          </md-button>
          <md-button
            :class="
              !profileInfo || pdfLoading
                ? 'md-info access-button pdf_btn disabled'
                : 'md-info access-button pdf_btn'
            "
            @click="downloadPDFData"
          >
            <md-icon class="ml-5">picture_as_pdf</md-icon
            >{{
              pdfLoading
                ? "Downloading"
                : !profile
                ? "Loading..."
                : "Download PDF"
            }}
          </md-button>
          <md-button
            :class="
              !profileInfo
                ? 'md-info access-button pdf_btn disabled'
                : 'md-info access-button pdf_btn'
            "
            v-on:click="downloadCSVData"
          >
            <md-icon class="ml-5">receipt_long</md-icon
            >{{ !profile ? "Loading..." : "Download CSV" }}
          </md-button>
        </div>
      </div>
    </div>
    <modal
      v-if="feedbackModal"
      @close="feedbackModal = false"
      class="feedback_modal"
    >
      <template slot="body">
        <button type="button" class="close_btn" @click="feedbackModal = false">
          <md-icon>clear</md-icon>
        </button>
        <h3 class="modal-title">Have feedback on this product?</h3>
        <p>
          Enter the details below to send your feedback to our Product Team.
        </p>
        <form action class="form_grp">
          <div class="field_wpr">
            <label>Leave A Feedback Note</label>
            <textarea
              v-model="textFeedback"
              placeholder="Type a message"
            ></textarea>
            <md-field>
              <md-select v-model="category" name="category">
                <md-option
                  v-for="(option, key) in optionsCategory"
                  :key="key"
                  :label="option"
                  :value="key"
                  >{{ option }}
                </md-option>
              </md-select>
            </md-field>
            <md-button @click="sendFeedback" class="md-info md-round mt-4"
              >Send Feedback</md-button
            >
          </div>
        </form>
      </template>
    </modal>
    <div class="md-layout-item md-size-100" v-if="user && headerData">
      <PdfDocument ref="cppdf" :headerInfo="{ headerData, user }" />
    </div>
  </div>
</template>
<script>
import { Modal } from "@/components";
import { mapActions, mapState } from "vuex";
import Avatar from "vue-avatar";
//import VueHtml2pdf from 'vue-html2pdf';
import PdfDocument from "./PdfDocument.vue";
import axios from "axios";

export default {
  components: {
    Modal,
    // Avatar,
    // VueHtml2pdf,
    PdfDocument,
  },
  props: ["headerData"],
  data() {
    return {
      optionsCategory: {
        0: "Select a Category",
        1: "1 - Report an Error",
        2: "2 - Suggest an Improvement",
        3: "3 - Request a Correction",
        4: "4 - Request an Update",
      },

      category: 0,
      userIP: null,
      loading: false,
      feedbackModal: false,
      textFeedback: "",
      filtered_company_profile_list: [],
    };
  },
  computed: {
    ...mapState({
      auth_user: (state) => state.user,
      profile: (state) => {
        return state.user.profile;
      },
      pdfLoading: (state) => state.user.pdfLoading,
    }),
    user() {
      return this.$store.state.user.user;
    },
    profileId() {
      return this.$route.params.id;
    },
    profileInfo() {
      return this.$store.getters.profileInfo;
    },
    companyReportSummary() {
      return this.$store.getters["user/companyReport"];
    },
    companyReportReleaseDisplay() {
      return this.$store.getters.companyReportReleaseDisplay;
    },
    ifInfo() {
      return this.$store.getters.profileInfo;
    },
    getFormattedData() {
      let a = {};

      a.company = this.ifInfo.companyTitle;
      a.original_name = "";
      a.infogroup = this.ifInfo.locnum;
      a.unique_id = "";
      a.street = this.ifInfo.street ? this.ifInfo.street : "";
      a.city = this.ifInfo.city ? this.ifInfo.city : "";
      a.state = this.ifInfo.state ? this.ifInfo.state : "";
      a.zip = this.ifInfo.zip ? this.ifInfo.zip : "";
      a.industry_code = this.ifInfo.naics;
      a.industry = this.ifInfo.industry;

      let b = this.ifInfo.businessOwner
        ? this.ifInfo.businessOwner.split(",")[0]
        : "";
      a.contact_first = b.split(" ")[0];
      a.contact_last = b.split(" ")[1];
      a.phone = this.ifInfo.businessPhone ? this.ifInfo.businessPhone : "";
      a.url = this.ifInfo.businessURL ? this.ifInfo.businessURL : "";
      let g = this.ifInfo.release_id.replace("_", "-01-20");
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      a.operation_details =
        monthNames[new Date(g).getMonth()] + " " + new Date(g).getFullYear();
      a.location_annual_sales = this.ifInfo.bizop["Location Sales"][0];
      a.location_employment = this.ifInfo.bizop["Employment"][0];
      a.corporation_annual_sales = this.ifInfo.bizop["Corporate Sales"][0];
      a.corporation_employment = this.ifInfo.bizop["Corporate Employment"][0];

      a.market_insights_date =
        monthNames[new Date(g).getMonth()] + " " + new Date(g).getFullYear();
      a.market_industry_code = this.ifInfo.IMRnaics;
      a.market_industry = this.ifInfo.IMRindustry;
      a.market_area = this.ifInfo["MR"]["area"];

      a.industry_operations = this.ifInfo["MR"]["main"]["Industry Operations"];
      a.location_sales_rank = this.ifInfo["MR"]["main"]["Business Sales Rank"];
      a.industry_market_sales_volume = this.ifInfo["MR"]["main"][
        "Annual Market Sales Volume"
      ];
      a.average_site_sales = this.ifInfo["MR"]["main"]["Average Site Sales"];
      a.average_small_business_sales = this.ifInfo["MR"]["main"][
        "Average Small Business Sales"
      ];

      a.industry_market_sales_per_person = this.ifInfo["MR"]["penetration"][
        "Market Sales per Person"
      ];
      a.us_industry_sales_per_person = this.ifInfo["MR"]["penetration"][
        "US Sales per Person"
      ];
      a.opportunity_index_person = this.ifInfo["MR"]["penetration"][
        "Opportunity Index Person"
      ];
      a.industry_market_sales_per_household = this.ifInfo["MR"]["penetration"][
        "Market Sales per Household"
      ];
      a.us_industry_sales_per_household = this.ifInfo["MR"]["penetration"][
        "US Sales per Household"
      ];
      a.opportunity_index_household = this.ifInfo["MR"]["penetration"][
        "Opportunity Index Household"
      ];

      a.market_area_population = this.ifInfo["MR"]["income"]["Population"];
      a.market_area_households = this.ifInfo["MR"]["income"]["Households"];
      a.per_capita_income = this.ifInfo["MR"]["income"]["Per Capita Income"];
      a.mediab_hh__income = this.ifInfo["MR"]["income"]["Median HH Income"];
      a.business_values_insights_date =
        monthNames[new Date(g).getMonth()] + " " + new Date(g).getFullYear();

      a.sales_approach_quartile1 = this.ifInfo.multiples.data["Quartile 1"][
        "sales"
      ];
      a.sales_approach_median = this.ifInfo.multiples.data["Median"]["sales"];
      a.sales_approach_quartile3 = this.ifInfo.multiples.data["Quartile 3"][
        "sales"
      ];
      a.earnings_approach_quartile1 = this.ifInfo.multiples.data["Quartile 1"][
        "earnings"
      ];
      a.earnings_approach_median = this.ifInfo.multiples.data["Median"][
        "earnings"
      ];
      a.earnings_approach_quartile3 = this.ifInfo.multiples.data["Quartile 3"][
        "earnings"
      ];

      a.if_industry_code = this.ifInfo.naics;
      a.if_industry_name = this.ifInfo.industry;
      a.if_industry_sales_class = this.ifInfo.IF["sales-class"];
      a.financial_insights_date = this.ifInfo.IF["period"];

      a.gross_margin_percentage = this.ifInfo.IF.spend[
        "Gross Margin"
      ].percentage;
      a.office_owner_compensation_percentage = this.ifInfo.IF.spend[
        "Officer-Owner-Compensation"
      ].percentage;
      a.depreciation_percentage = this.ifInfo.IF.spend[
        "Depreciation"
      ].percentage;
      a.operating_expense_percentage = this.ifInfo.IF.spend[
        "Operating Expenses"
      ].percentage;
      a.operating_income_percentage = this.ifInfo.IF.spend[
        "Operating Income"
      ].percentage;
      a.after_tax_net_profit_percentage = this.ifInfo.IF.spend[
        "After Tax Net Profit"
      ].percentage;
      a.owner_earnings_percentage = this.ifInfo.IF.spend[
        "Owner Earnings"
      ].percentage;
      a.account_receivable_percentage = this.ifInfo.IF.spend[
        "Accounts Receivable: Total Assets"
      ].percentage;
      a.account_payable_percentage = this.ifInfo.IF.spend[
        "Accounts Payable: TLNW"
      ].percentage;
      a.net_worth_assets_percentage = this.ifInfo.IF.spend[
        "Net Worth: Assets"
      ].percentage;

      a.gross_margin_dollar = this.ifInfo.IF.spend["Gross Margin"].dollar;
      a.office_owner_compensation_dollar = this.ifInfo.IF.spend[
        "Officer-Owner-Compensation"
      ].dollar;
      a.depreciation_dollar = this.ifInfo.IF.spend["Depreciation"].dollar;
      a.operating_expense_dollar = this.ifInfo.IF.spend[
        "Operating Expenses"
      ].dollar;
      a.operating_income_dollar = this.ifInfo.IF.spend[
        "Operating Income"
      ].dollar;
      a.after_tax_net_profit_dollar = this.ifInfo.IF.spend[
        "After Tax Net Profit"
      ].dollar;
      a.owner_earnings_dollar = this.ifInfo.IF.spend["Owner Earnings"].dollar;
      a.account_receivable_dollar = this.ifInfo.IF.spend[
        "Accounts Receivable: Total Assets"
      ].dollar;
      a.account_payable_dollar = this.ifInfo.IF.spend[
        "Accounts Payable: TLNW"
      ].dollar;
      a.net_worth_assets_dollar = this.ifInfo.IF.spend[
        "Net Worth: Assets"
      ].dollar;

      a.account_payable_revenue = this.ifInfo.IF.benchmarks[
        "Accounts Payable: Revenue"
      ];
      a.current_ratio = this.ifInfo.IF.benchmarks["Current Ratio"];
      a.days_payable = this.ifInfo.IF.benchmarks["Days Payable"];
      a.net_working_capital_revenue = this.ifInfo.IF.benchmarks[
        "Net Working Capital Revenue"
      ];
      a.days_receivable = this.ifInfo.IF.benchmarks["Days Receivable"];
      a.interest_coverage = this.ifInfo.IF.benchmarks["Interest Coverage"];
      a.current_liabilites = this.ifInfo.IF.benchmarks[
        "Current Liabilities: NW"
      ];
      a.loans_notes = this.ifInfo.IF.benchmarks[
        "Loans‐Notes Payable: Net Worth"
      ];
      a.modified_z = this.ifInfo.IF.benchmarks["Modified Z Score"];
      a.total_liabilities = this.ifInfo.IF.benchmarks[
        "Total Liabilties: Net Worth"
      ];

      Object.values(a).forEach((element, index) => {
        let b = "";
        if (element && element.includes(",")) {
          b = element.replace(/,/g, ".");
        } else {
          b = element;
        }
        this.filtered_company_profile_list.push(b);
      });
      return this.filtered_company_profile_list;
    },
    getCsvData() {
      let csvData = [
        [
          "Company",
          "Original Name",
          "Infogroup ID",
          "Unique ID",
          "Street",
          "City",
          "State",
          "Zip",
          "Industry Code",
          "Industry",
          "Contact First",
          "Contact Last",
          "Phone",
          "URL",
          "Operation Detail Release",
          "Location Annual Sales",
          "Location Employment",
          "Corporate Annual Sales",
          "Corporate Employment",
          "Market Insights Date",
          "Market Industry Code",
          "Market Industry",
          "Market Area",
          "Industry Operations",
          "Location Sales Rank",
          "Industry Market Sales Volume",
          "Average Site Sales",
          "Average Small Business Sales",
          "Industry Market Sales per Person",
          "US Industry Sales per Person",
          "Opportunity Index",
          "Industry Market Sales per Household",
          "US Industry Sales per Household",
          "Opportunity Index",
          "Market Area Population",
          "Market Area Households",
          "Per Capital Income",
          "Median Household Income",
          "Business Value Insights Date",
          "Sales Approach Quartile1",
          "Sales Approach Median",
          "Sales Approach Quartile3",
          "Earnings Approach Quartile1",
          "Earnings Approach Median",
          "Earnings Approach Quartile3",
          "IF Industry code",
          "IF Industry name",
          "IF Sales class",
          "Financial Insights Date",
          "Gross Margin %",
          "Officer-Owner Compensation %",
          "Depreciation %",
          "Operating Expense %",
          "Operating Income %",
          "After Tax Net Profit %",
          "Owner Earnings %",
          "Accounts Receivable/Total Assets %",
          "Accounts Payable/TLNW %",
          "Net Worth/Assets %",
          "Gross Margin $",
          "Officer-Owner Compensation $",
          "Depreciation $",
          "Operating Expense $",
          "Operating Income $",
          "After Tax Net Profit $",
          "Owner Earnings $",
          "Accounts Receivable/Total Assets $",
          "Accounts Payable/TLNW $",
          "Net Worth/Assets $",
          "Accounts Payable/Revenue",
          "Current Ratio",
          "Days Payable",
          "Net Working Capital/Revenue",
          "Days Receivable",
          "Interest Coverage",
          "Current Liabilities/Net Worth",
          "Loans Notes Payable/Net Worth",
          "Modified Z Score",
          "Total Liabilties/Net Worth",
        ],
      ];

      csvData.push(this.getFormattedData);
      return csvData;
    },
    /* pdfDownloadSetting() {
      return this.user && this.user.preferences && this.user.preferences.defaultPDFDownload ? this.user.preferences.defaultPDFDownload : '_blank'
    },*/
  },
  mounted() {
    this.$store.commit("user/SET_PDF_LOADING", false);
    this.getUserIP();
  },
  methods: {
    ...mapActions({
      auth_user: (state) => state.user,
      registerProductExport: "tracking/registerProductExport",
    }),
    downloadPDFData() {
      this.$refs.cppdf.generateReport();
      this.registerProductExport({
        userId: this.auth_user?.user?.userID,
        productId: this.$route.params.id,
        exportType: "PDF",
      });
      /*this.$store.commit('user/SET_PDF_LOADING', true);
      this.$refs.html2Pdf.generatePdf()
      setTimeout(() => {
        this.$store.commit('user/SET_PDF_LOADING', false);
      }, 10000);*/
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      await html2pdf()
        .set(options)
        .from(pdfContent)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          if (!this.$store.getters["user/pdfMustBeDownloaded"])
            window.open(pdf.output("bloburl"), "_blank");
        });
    },

    feedback() {
      this.feedbackModal = true;
    },
    sendFeedback() {
      let parameters = {};

      parameters["name"] = "Company Profile";
      parameters["Industry"] = this.headerData;

      parameters = JSON.stringify(parameters);

      if (this.category) {
        let currentSession = localStorage.getItem(
          "vue-authenticate.vueauth_access_token"
        );
        axios
          .post(
            process.env.VUE_APP_API_BASE_URL + "/user/feedback/submit",
            {},
            {
              params: {
                session_id: currentSession,
                feedback: this.textFeedback,
                ip: `${this.userIP}`,
                url: `${window.location.href}`,
                category: this.category,
                parameters: parameters,
              },
            }
          )
          .then((res) => {
            if (res.hasOwnProperty("data") && res.data.error) {
              this.$store.commit("SET_ERROR_BIT", true);
              this.$store.commit(
                "SET_ERROR_INFO",
                "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/feedback/submit" <br>`
              );
              throw new Error(
                "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode
              );
            }

            if (res.data.success)
              this.$store.dispatch("alerts/success", "Successfully sent");
            else
              this.$store.dispatch(
                "alerts/error",
                "An error occured. please try again"
              );

            this.feedbackModal = false;
            this.textFeedback = null;
            this.category = null;

            this.checkBoxOption1 = false;
            this.checkBoxOption2 = false;
            this.checkBoxOption3 = false;
            this.checkBoxOption4 = false;
          });
      } else {
        this.$store.commit("SET_ERROR_BIT", true);
        this.$store.commit(
          "SET_ERROR_INFO",
          "<br>" +
            "Server responded with error = True <br> errorCode: " +
            "category_not_set" +
            `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/feedback/submit" <br>`
        );
      }
    },
    getUserIP() {
      try {
        fetch("https://api.ipify.org?format=json", {
          mode: "no-cors",
        })
          .then((x) => x.json())
          .then(({ ip }) => {
            this.userIP = ip;
          });
      } catch (err) {}
    },
    switchView: function(type) {
      this.view = type;
    },
    numberWithPoints(x) {
      if (typeof x === "number") {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      } else if (x === null) {
        return x;
      } else {
        return x.replace(/,/g, ".");
      }
    },
    downloadCSVData() {
      let csv = "";
      this.getCsvData.forEach((row) => {
        csv += row.join(",");
        csv += "\n";
      });
      const anchor = document.createElement("a");
      anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
      anchor.target = "_blank";
      anchor.download = "Company Profile.csv";
      anchor.click();
      this.registerProductExport({
        userId: this.auth_user?.user?.userID,
        productId: this.$route.params.id,
        exportType: "CSV",
      });
    },
  },
};
</script>
